import { get, post, patch, del } from './client.js';
export { normTask } from './enums.js';

const base = (wsId) => `/workspaces/${wsId}/tasks`;

export const list = (wsId, params) => {
  const q = params ? '?' + new URLSearchParams(params).toString() : '';
  return get(`${base(wsId)}${q}`);
};

export const getOne = (wsId, taskId) => get(`${base(wsId)}/${taskId}`);
export const create = (wsId, body) => post(base(wsId), body);
export const update = (wsId, taskId, body) => patch(`${base(wsId)}/${taskId}`, body);
export const remove = (wsId, taskId) => del(`${base(wsId)}/${taskId}`);

/* Lifecycle transitions — backend uses POST, not PATCH */
export const complete = (wsId, taskId) => post(`${base(wsId)}/${taskId}/complete`);
export const reopen   = (wsId, taskId) => post(`${base(wsId)}/${taskId}/reopen`);
export const cancel   = (wsId, taskId) => post(`${base(wsId)}/${taskId}/cancel`);
export const start    = (wsId, taskId) => post(`${base(wsId)}/${taskId}/start`);

/* One-way archive (no restore endpoint) — requires CRM_MANAGE */
export const archive = (wsId, taskId) => post(`${base(wsId)}/${taskId}/archive`);

